import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TrialAccountsStateService } from './trial-accounts-state.service';
import { TrialAccountsRequestsEffects } from './store/effects';
import { TrialAccountReducer } from './store/reducer';
import { TrialAccountsService } from './services/trial-accounts.service';
import { stateName } from './store/state';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(stateName, TrialAccountReducer),
    EffectsModule.forFeature([TrialAccountsRequestsEffects]),
  ],
  providers: [TrialAccountsService, TrialAccountsStateService],
})
export class TrialAccountsStateModule {}
